import React from "react";
import { useTheme } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";
import useStyles from "./codeSnippetStyles";
import { CopyButton } from "../common";
import { Light as SyntaxHighlighter } from "react-syntax-highlighter";
import htmlbars from "react-syntax-highlighter/dist/cjs/languages/hljs/htmlbars";
import arduinoLight from "react-syntax-highlighter/dist/cjs/styles/hljs/arduino-light";

SyntaxHighlighter.registerLanguage("htmlbars", htmlbars);

const CodeSnippet = ({ code }) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Box
      bgcolor={theme.palette.change.main}
      padding={1}
      borderRadius="borderRadius"
      color={theme.palette.common.white}
    >
      <Box display="flex" alignItems="center" justifyContent="flex-end">
        <CopyButton copy={code} withLabel />
      </Box>
      <SyntaxHighlighter
        language="htmlbars"
        style={arduinoLight}
        className={classes.code}
        customStyle={{
          backgroundColor: theme.palette.change.main,
        }}
      >
        {code}
      </SyntaxHighlighter>
    </Box>
  );
};

export default CodeSnippet;
